/**
 * Milo Mer — hover & mobile autoplay for product-card videos
 * - Dawn cards:  <video.card__hover-video> inside .card__media
 * - Milo grid:   <video.mm-hover-video>   inside .mm-card .mm-thumb
 * We start videos muted in the background; hover simply reveals them.
 */
(function () {
  /* ---------- helpers ---------- */
  function prime(video) {
    if (!video) return;
    video.muted = true; video.defaultMuted = true; video.setAttribute('muted','');
    video.playsInline = true; video.setAttribute('playsinline',''); video.setAttribute('webkit-playsinline','');
    video.preload = 'auto';
    video.autoplay = true; // safe because muted
    video.volume = 0;
  }

  function kick(video) {
    if (!video) return;
    try { if (video.currentTime === 0) video.currentTime = 0.02; } catch (e) {}
    var p = video.play();
    if (p && p.catch) {
      p.catch(function () {
        // ensure decodable frame then retry
        if (video.readyState < 2) { try { video.load(); } catch (e) {} }
        var fired = false;
        function go() {
          if (fired) return; fired = true;
          try { video.play(); } catch (e) {}
        }
        video.addEventListener('loadeddata', go, { once: true });
        video.addEventListener('canplay', go, { once: true });
        setTimeout(go, 400);
      });
    }
  }

  function wire(hoverEl, videoSelector) {
    if (!hoverEl) return;
    var video = hoverEl.querySelector(videoSelector);
    if (!video) return;

    prime(video);
    // start in background; hover just reveals via CSS
    kick(video);

    function onEnter() { kick(video); }
    function onLeave() { try { video.pause(); video.currentTime = 0; } catch (e) {} }

    hoverEl.addEventListener('mouseenter', onEnter);
    hoverEl.addEventListener('pointerenter', onEnter);
    hoverEl.addEventListener('mouseleave', onLeave);
    hoverEl.addEventListener('pointerleave', onLeave);
  }

  /* ---------- init on page load ---------- */
  function init() {
    // Dawn product cards
    document.querySelectorAll('.card__media').forEach(function (el) { wire(el, 'video.card__hover-video'); });
    // Milo grid cards
    document.querySelectorAll('.mm-card').forEach(function (el) { wire(el, 'video.mm-hover-video'); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // late mounts
  setTimeout(init, 600);

  // watch for dynamically added cards
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        (m.addedNodes || []).forEach(function (n) {
          if (!(n instanceof Element)) return;
          if (n.matches && n.matches('.card__media')) wire(n, 'video.card__hover-video');
          if (n.matches && n.matches('.mm-card')) wire(n, 'video.mm-hover-video');
          n.querySelectorAll && n.querySelectorAll('.card__media, .mm-card').forEach(function (x) {
            wire(x, x.classList.contains('mm-card') ? 'video.mm-hover-video' : 'video.card__hover-video');
          });
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- mobile auto-toggle: first & last cards (10 replays) ---------- */
  (function () {
    function isTouchMobile() {
      return window.matchMedia &&
             window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    }
    function reduceMotion() {
      return window.matchMedia &&
             window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    var MM_FADE_MS   = 600;   // match your CSS opacity transition (ms)
    var LOOPS_TARGET = 10;    // replay count before reverting
    var INTERVAL_MS  = 10000; // cadence for showing first/last
    var FIRST_DELAY  = 1000;

    var timer = null;
    var kickTimeout = null;

    function cards() {
      var grid = document.querySelector('.mm-grid');
      return grid ? grid.querySelectorAll('.mm-card') : [];
    }
    function first() { var c = cards(); return c.length ? c[0] : null; }
    function last()  { var c = cards(); return c.length ? c[c.length - 1] : null; }

    function showAlt(card) {
      if (!card) return;
      if (card.classList.contains('is-alt')) return; // avoid stacking while already active
      card.classList.add('is-alt');

      var v = card.querySelector('video.mm-hover-video');
      if (v) {
        // Make sure it’s primed for silent inline autoplay
        v.muted = true; v.defaultMuted = true; v.setAttribute('muted','');
        v.playsInline = true; v.setAttribute('playsinline',''); v.setAttribute('webkit-playsinline','');
        v.preload = 'auto'; v.autoplay = true; v.volume = 0;

        // Count loops ourselves; disable native loop while auto-toggling
        v.loop = false;

        var loops = 0;
        var endedHandler, watchdog;

        function start() {
          try { if (v.readyState < 2) v.load(); } catch(e){}
          try { v.currentTime = 0; } catch(e){}
          var p = v.play(); if (p && p.catch) p.catch(function(){});
        }

        function clearAll() {
          if (endedHandler) { v.removeEventListener('ended', endedHandler); endedHandler = null; }
          if (watchdog) { clearTimeout(watchdog); watchdog = null; }
        }

        function revert() {
          clearAll();
          // Fade back to primary
          card.classList.remove('is-alt');
          // Pause/reset AFTER the fade so it feels seamless
          setTimeout(function(){
            try { v.pause(); v.currentTime = 0; } catch(e){}
            v.loop = true; // restore default
          }, MM_FADE_MS);
        }

        endedHandler = function() {
          loops += 1;
          if (loops < LOOPS_TARGET) {
            start(); // replay
          } else {
            revert();
          }
        };
        v.addEventListener('ended', endedHandler);

        // Safety watchdog in case duration unknown or ended isn't firing
        var perLoop = (isFinite(v.duration) && v.duration > 0) ? v.duration * 1000 : 4000;
        watchdog = setTimeout(revert, perLoop * LOOPS_TARGET + 2000);

        // kick off first play
        start();
      } else {
        // Secondary is an image: hold briefly then fade back
        setTimeout(function(){ card.classList.remove('is-alt'); }, 2000);
      }
    }

    function startAuto() {
      if (timer || kickTimeout) return;
      kickTimeout = setTimeout(function () { showAlt(first()); showAlt(last()); }, FIRST_DELAY);
      timer = setInterval(function () { showAlt(first()); showAlt(last()); }, INTERVAL_MS);
    }

    function stopAuto() {
      if (kickTimeout) { clearTimeout(kickTimeout); kickTimeout = null; }
      if (timer) { clearInterval(timer); timer = null; }
      // Clean up any active states if we leave mobile conditions
      document.querySelectorAll('.mm-card.is-alt').forEach(function (c) {
        c.classList.remove('is-alt');
      });
    }

    function apply() {
      if (isTouchMobile() && !reduceMotion()) startAuto();
      else stopAuto();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', apply);
    } else {
      apply();
    }

    // Re-evaluate on viewport/device changes & tab visibility
    window.addEventListener('resize', function(){ setTimeout(apply, 150); });
    document.addEventListener('visibilitychange', function(){
      if (document.hidden) stopAuto(); else apply();
    });
  })();
})();
